import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _chunk from "lodash/chunk";
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.map.js";
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { createSamples, createSampleFile, updateSampleFileUpload, validateSamples } from 'redux/actions/samples';
import UploadStatus from 'utils/upload/UploadStatus';
import { inspectFile, Verdict } from 'utils/upload/fileInspector';
import fetchAPI from 'utils/http/fetchAPI';
import { sampleTech } from 'utils/constants';
import fileUploadUtils from 'utils/upload/fileUploadUtils';
import endUserMessages from 'utils/endUserMessages';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import UploadsCoordinator from 'utils/upload/UploadsCoordinator';
import UploadsCoordinatorError from 'utils/errors/upload/UploadsCoordinatorError';
import FileUploaderError from 'utils/errors/upload/FileUploaderError';
var createAndUploadSampleFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, fileType, experimentId, sampleId, dispatch, selectedTech) {
    var abortController, sampleFileId, fileName, _uploadUrlParams, _updateSampleFileUploadProgress, _options;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            abortController = new AbortController();
            _context.prev = 1;
            _context.next = 4;
            return dispatch(createSampleFile(experimentId, sampleId, fileType, file, abortController));
          case 4:
            sampleFileId = _context.sent;
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            pushNotificationMessage('error', endUserMessages.ERROR_BEGIN_SAMPLE_FILE_UPLOAD);
            return _context.abrupt("return");
          case 11:
            // Take the fileName now because after loadAndCompressIfNecessary the name could
            // be lost in the compression. If it is compressed fileObject becomes a uInt8Array
            // instead of the fileReader metadata object that it is now
            fileName = file.fileObject.name;
            _context.prev = 12;
            _context.next = 15;
            return beginSampleFileUpload(experimentId, sampleFileId, getMetadata(fileName, selectedTech));
          case 15:
            _uploadUrlParams = _context.sent;
            _updateSampleFileUploadProgress = function _updateSampleFileUploadProgress(status) {
              var percentProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              dispatch(updateSampleFileUpload(experimentId, sampleId, sampleFileId, fileType, status, percentProgress));
            };
            _options = {
              compress: !file.compressed
            };
            _context.next = 20;
            return UploadsCoordinator.get().uploadFile([experimentId, file, _uploadUrlParams, 'sample', abortController, _updateSampleFileUploadProgress, _options]);
          case 20:
            _context.next = 25;
            break;
          case 22:
            _context.prev = 22;
            _context.t1 = _context["catch"](12);
            dispatch(updateSampleFileUpload(experimentId, sampleId, sampleFileId, fileType, UploadStatus.UPLOAD_ERROR));
          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7], [12, 22]]);
  }));
  return function createAndUploadSampleFile(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();
var beginSampleFileUpload = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(experimentId, sampleFileId, metadata) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/sampleFiles/").concat(sampleFileId, "/beginUpload"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                metadata: metadata
              })
            });
          case 2:
            return _context2.abrupt("return", _context2.sent);
          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function beginSampleFileUpload(_x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();
var getMetadata = function getMetadata(fileName, selectedTech) {
  var metadata = {};
  if (selectedTech === sampleTech['10X']) {
    if (fileName.includes('genes')) {
      metadata.cellranger_version = 'v2';
    } else if (fileName.includes('features')) {
      metadata.cellranger_version = 'v3';
    }
  }
  return metadata;
};
var processSampleUpload = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(filesList, technology, samples, experimentId, dispatch) {
    var samplesMap, validSamplesList, _sampleIdsByName, _promises, _chunkedPromises, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _promisesChunk;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // First use map to make it easy to add files in the already existing sample entry
            samplesMap = filesList.reduce(function (acc, file) {
              var _Object$values$filter, _acc$sampleName;
              var _fileUploadUtils$tech = fileUploadUtils[technology].getFileSampleAndName(file.fileObject.path.replace(/[\s]{2,}/ig, ' ')),
                sampleName = _fileUploadUtils$tech.sample,
                name = _fileUploadUtils$tech.name;
              var fileType = fileUploadUtils[technology].getCorrespondingType(name);
              var sampleUuid = (_Object$values$filter = Object.values(samples).filter(function (s) {
                return s.name === sampleName && s.experimentId === experimentId;
              })[0]) === null || _Object$values$filter === void 0 ? void 0 : _Object$values$filter.uuid;
              return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, sampleName, _objectSpread(_objectSpread({}, acc[sampleName]), {}, {
                uuid: sampleUuid,
                files: _objectSpread(_objectSpread({}, (_acc$sampleName = acc[sampleName]) === null || _acc$sampleName === void 0 ? void 0 : _acc$sampleName.files), {}, _defineProperty({}, fileType, file))
              })));
            }, {});
            _context4.next = 3;
            return dispatch(validateSamples(experimentId, samplesMap, technology));
          case 3:
            validSamplesList = _context4.sent;
            if (!(validSamplesList.length === 0)) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return");
          case 6:
            // Sort alphabetically
            validSamplesList.sort(function (_ref4, _ref5) {
              var _ref6 = _slicedToArray(_ref4, 1),
                oneName = _ref6[0];
              var _ref7 = _slicedToArray(_ref5, 1),
                otherName = _ref7[0];
              return oneName.localeCompare(otherName);
            });
            _context4.prev = 7;
            _context4.next = 10;
            return dispatch(createSamples(experimentId, validSamplesList, technology));
          case 10:
            _sampleIdsByName = _context4.sent;
            _promises = [];
            validSamplesList.forEach(function (_ref8) {
              var _ref9 = _slicedToArray(_ref8, 2),
                name = _ref9[0],
                sample = _ref9[1];
              Object.entries(sample.files).forEach(function (_ref0) {
                var _ref1 = _slicedToArray(_ref0, 2),
                  type = _ref1[0],
                  file = _ref1[1];
                _promises.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return createAndUploadSampleFile(file, type, experimentId, _sampleIdsByName[name], dispatch, technology);
                        case 2:
                          return _context3.abrupt("return", _context3.sent);
                        case 3:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })));
              });
            });

            // 5 at a time
            _chunkedPromises = _chunk(_promises, _promises.length); // eslint-disable-next-line no-restricted-syntax
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context4.prev = 16;
            _iterator = _asyncIterator(_chunkedPromises);
          case 18:
            _context4.next = 20;
            return _iterator.next();
          case 20:
            if (!(_iteratorAbruptCompletion = !(_step = _context4.sent).done)) {
              _context4.next = 27;
              break;
            }
            _promisesChunk = _step.value;
            _context4.next = 24;
            return Promise.all(_promisesChunk.map(function (promise) {
              return promise();
            }));
          case 24:
            _iteratorAbruptCompletion = false;
            _context4.next = 18;
            break;
          case 27:
            _context4.next = 33;
            break;
          case 29:
            _context4.prev = 29;
            _context4.t0 = _context4["catch"](16);
            _didIteratorError = true;
            _iteratorError = _context4.t0;
          case 33:
            _context4.prev = 33;
            _context4.prev = 34;
            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context4.next = 38;
              break;
            }
            _context4.next = 38;
            return _iterator.return();
          case 38:
            _context4.prev = 38;
            if (!_didIteratorError) {
              _context4.next = 41;
              break;
            }
            throw _iteratorError;
          case 41:
            return _context4.finish(38);
          case 42:
            return _context4.finish(33);
          case 43:
            _context4.next = 47;
            break;
          case 45:
            _context4.prev = 45;
            _context4.t1 = _context4["catch"](7);
          case 47:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[7, 45], [16, 29, 33, 43], [34,, 38, 42]]);
  }));
  return function processSampleUpload(_x0, _x1, _x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}();

/**
   * This function converts an uploaded File object into a file record that will be inserted under
   * samples[files] in the redux store.
   * @param {File} fileObject the File object that is uploaded to the .
   * @param {string} technology the chosen technology that outputs this file. Used for verification.
   * @returns {object} fileRecord object that will be associated with a sample.
   */
var fileObjectToFileRecord = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(fileObject, technology) {
    var verdict, error;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return inspectFile(fileObject, technology);
          case 2:
            verdict = _context5.sent;
            error = '';
            if (verdict === Verdict.INVALID_NAME) {
              error = 'Invalid file name.';
            } else if (verdict === Verdict.INVALID_FORMAT) {
              error = 'Invalid file format.';
            }
            return _context5.abrupt("return", {
              fileObject: fileObject,
              size: fileObject.size,
              path: fileObject.path,
              upload: {
                status: UploadStatus.UPLOADING,
                progress: 0
              },
              errors: error,
              compressed: verdict === Verdict.VALID_ZIPPED
            });
          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function fileObjectToFileRecord(_x13, _x14) {
    return _ref11.apply(this, arguments);
  };
}();
export { fileObjectToFileRecord, createAndUploadSampleFile };
export default processSampleUpload;